<template>
  <v-app id="inspire">
    <nprogress-container></nprogress-container>

    <v-app-bar app color="primary" clipped-left>
      <v-toolbar-title>
        Centro Sanum
      </v-toolbar-title>

      <v-spacer />

      <v-menu :nudge-width="200" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-list v-if="username">
            <v-list-item>
              <v-list-item-avatar>
                <v-avatar color="primary">
                  <span>{{ getInitials(username) }}</span>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ username }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider />

            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>

              <v-list-item-title>Salir</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-list v-else>
            <v-list-item to="/login">
              <v-list-item-icon>
                <v-icon>mdi-login</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Login</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-content>
      <v-container>
        <router-view />
      </v-container>
    </v-content>

    <v-footer app inset>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} —
        <strong>built by Elitek Solutions</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import initials from "node-initials";
import NprogressContainer from "vue-nprogress/src/NprogressContainer";
export default {
  components: { NprogressContainer },
  data: () => ({
    mini: true,
  }),
  computed: {
    ...mapState({
      isDark: (state) => state.style.isDark,
    }),
    username() {
      return this.$store.getters["auth/username"];
    },
    routes() {
      return this.$router.options.routes.filter((route) => route.main);
    },
  },
  methods: {
    ...mapMutations({
      logout: "auth/logout",
      switchTheme: "style/switchTheme",
    }),
    getInitials(name) {
      return initials(name);
    },
  },
  beforeCreate() {
    this.$store.dispatch("auth/initialize");
  },
};
</script>
